module.exports = {"ApprovalRuleId":"_","Name":"Name","CreatedBy":"Created By","CreatedDateFormatted":"Created","UpdatedBy":"Updated By","UpdatedDateFormatted":"Last Updated"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-list/model.json
// module id = lOj7
// module chunks = 12